import api from './index';

export const addUserInfo = (userInfo) => api.API.post('/user', userInfo);
export const getUserInfo = (id) => api.API.get(`/user/${id}`);
